<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col cols="12" md="6" class="d-flex justify-center my-8">
          <div class="visual-preview-container">
            <div class="measure-line top-measure">
              <span>{{ totalSize }}px</span>
            </div>
            
            <div class="qr-margin-box" :style="marginStyle">  
              <div class="qr-image blue-svg-mask"></div>            
            </div>

            <div class="measure-line right-measure">
              <span>{{ totalSize }}px</span>
            </div>
          </div>
        </v-col>
        <v-col class="d-flex flex-column justify-center" cols="12" md="4" style="padding-top: 15px;">
          
          <div class="d-flex align-center mb-4">
            
            <!-- براکت و آیکون لینک (در حالت راست‌چین، این در سمت راست فیلدها رندر می‌شود) -->
            <div class="input-link-bracket mr-2 ml-3">
              <v-icon class="link-icon" size="20">mdi-link</v-icon>
            </div>

            <!-- فیلدهای عرض و ارتفاع -->
            <div class="flex-grow-1">
              <v-text-field
                :value="options.width"
                :label="$t('width')"
                min="27"
                outlined
                dense
                hide-details
                type="number"
                @input="updateSizes($event, 'width')"
                class="mb-3 contentinfo"
                prepend-inner-icon="mdi-arrow-expand-horizontal"
              />          
              <v-text-field
                :value="options.height"
                :label="$t('height')"
                min="27"
                outlined
                dense
                hide-details
                type="number"
                @input="updateSizes($event, 'height')"
                class="ma-0 contentinfo"
                prepend-inner-icon="mdi-arrow-expand-vertical"
              />
            </div>
            
          </div>

          <!-- فیلد حاشیه -->
          <v-text-field
            v-model.number="options.margin"
            :label="$t('margin')"
            min="0"
            outlined
            type="number"
            dense
            hide-details
            @input="$emit('update')"
            class="ma-0 contentinfo"
            prepend-inner-icon="mdi-border-all"
          />

        </v-col>

        <!-- تنظیمات رنگ پس‌زمینه -->
        <v-col class="d-flex align-center grey--text mt-4" cols="12">
          {{ $t('background_color') }}
          <v-divider class="mx-2" />
        </v-col>
        <v-col cols="12" md="6">
          <v-switch v-model="bgTranSwitch" label="پس‌زمینه شفاف" />
        </v-col>

        <v-col cols="12" md="6" v-if=!bgTranSwitch>
          <v-switch v-model="bgSwitch" :label="$t('gradient_color')" />
        </v-col>

        <template v-if="bgSwitch">
          <v-col class="pa-2" cols="12" md="6">
            <v-radio-group
              v-model="options.backgroundOptions.gradient.type"
              class="ma-0"
              row
              @change="$emit('update', true)"
            >
              <v-radio :label="$t('linear')" value="linear" />
              <v-radio :label="$t('radial')" value="radial" />
            </v-radio-group>
          </v-col>

          <v-col class="pa-2" cols="12">
            <v-slider
              v-model="computedRotation"
              append-icon="mdi-rotate-360"
              :label="$t('color_rotation')"
              max="360"
              min="0"
              thumb-label
              track-color="grey"
              @input="$emit('update', true)"
            >
              <template v-slot:thumb-label="{ value }">
                <div
                  class="d-flex align-center justify-center"
                  style="
                    width: 20px;
                    height: 20px;
                    background-color: rgba(12, 15, 26, 0.7);
                    border-radius: 50%;
                  "
                >
                  {{ value }}°
                </div>
              </template>
            </v-slider>
          </v-col>

          <v-col class="pa-2" cols="12" md="6" v-if=!bgTranSwitch>
            <color-picker
              v-model="options.backgroundOptions.gradient.colorStops[0].color"
              :label="$t('first_color')"
              @input="$emit('update', true)"
            />
          </v-col>

          <v-col class="pa-2" cols="12" md="6" v-if=!bgTranSwitch>
            <color-picker
              v-model="options.backgroundOptions.gradient.colorStops[1].color"
              :label="$t('second_color')"
              @input="$emit('update', true)"
            />
          </v-col>
        </template>

        <v-col v-if="!bgSwitch && !bgTranSwitch" class="pa-2" cols="12" md="6" >
          <color-picker
            v-model="options.backgroundOptions.color"
            :label="$t('background_color_label')"
            @input="$emit('update', true)"
          />
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrCodeData",

  components: { ColorPicker },

  props: {
    value: Object,
    readonly: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeData",
    bgSwitch: false,
    rotation: 0,
    bgTranSwitch:false,
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedRotation: {
      get() {
        return this.rotation;
      },
      set(val) {
        this.rotation = val;
        if (this.options.backgroundOptions?.gradient) {
          this.options.backgroundOptions.gradient.rotation = (val * Math.PI) / 180;
        }
        this.$emit("update", true);
      },
    },
    // استایل داینامیک برای پیش‌نمایش حاشیه
    marginStyle() {
      const basePadding = Number(this.options.margin) || 0;
      // محدود کردن پدینگ نمایشی که UI به هم نریزد (فقط برای نمایش)
      const visualPadding = Math.min(basePadding, 40); 
      return {
        padding: `${visualPadding}px`,
        backgroundColor: '#e0e0e0',
        borderRadius: '12px',
        border: '2px dashed #9e9e9e'
      };
    },
    // محاسبه سایز کل (طول + 2*حاشیه)
    totalSize() {
      const w = Number(this.options.width) || 0;
      const m = Number(this.options.margin) || 0;
      return w;
      // return w + (m * 2);
    }
  },

  watch: {
     "options.backgroundOptions": {
      deep: true,
      handler(val) {
        if (val.color === "#FFFFFFFF" && this.bgTranSwitch) {
          this.bgTranSwitch = false;
        }
        if (!val.gradient && this.bgSwitch) {
          this.bgSwitch = false;
        }
      }
    },
      bgTranSwitch(val) {
      if (val) {
        this.bgSwitch = false;        
        this.options.backgroundOptions.color = "#ffffff00";
      } else {
        this.options.backgroundOptions.color = "#ffffffff"; 
      }
      this.$emit("update", true);
    },
    bgSwitch(val) {
      if (!val) {
        this.options.backgroundOptions.gradient = null;
      } else {
        this.options.backgroundOptions.gradient = {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#ffffffff" },
            { offset: 1, color: "#ffffffff" },
          ],
        };
      }
      this.$emit("update", true);
    },
  },

  methods: {
    updateSizes(e, field) {
      let val = Number(e);
      if (val < 0) val = 0;
      
      this.options[field] = val;

      // متصل کردن عرض و ارتفاع به یکدیگر (مربع نگه داشتن QR کد)
      if (field === 'width') {
        this.options.height = val;
      } else if (field === 'height') {
        this.options.width = val;
      }

      this.$emit("update");
    },
  },
};
</script>

<style scoped>
.visual-preview-container {
  position: relative;
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 20px;
}

.qr-margin-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.qr-image {
  width: 120px;
  height: 120px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
}

.measure-line {
  position: absolute;
  border-color: #011554;
  color: #011554;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-measure {
  top: -25px;
  left: 0;
  right: 0;
  height: 15px;
  border-top: 2px solid #011554;
  border-left: 2px solid #011554;
  border-right: 2px solid #011554;
}

.top-measure span {
  background: white;
  padding: 0 8px;
  transform: translateY(-50%);
}

.right-measure {
  right: -25px;
  top: 0;
  bottom: 0;
  width: 15px;
  border-top: 2px solid #011554;
  border-right: 2px solid #011554;
  border-bottom: 2px solid #011554;
}

.right-measure span {
  writing-mode: vertical-rl;
  background: white;
  padding: 8px 0;
  transform: translateX(50%);
}
.margin-indicator {
  position: absolute;
  font-size: 11px;
  color: #757575;
  font-weight: bold;
  z-index: 2;
}
.top-left {
  top: 5px;
  left: 5px;
}
.link-icon {
  z-index: 1;
  color: #011554;
}
.blue-svg-mask {
  width: 100px; 
  height: 100px;
  background-color: #011554;   
  -webkit-mask: url('/media/img/Q.svg') no-repeat center / contain;
  mask: url('/media/img/Q.svg') no-repeat center / contain;
}
.input-link-bracket {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px; 
  width: 15px;
  border-top: 2px solid #011554;
  border-bottom: 2px solid #011554;
  border-right: 2px solid #011554; 
  position: relative;
}

.input-link-bracket .link-icon {
  position: absolute;
  right: -12px; 
  background-color: white;
  color: #011554 !important; 
  padding: 2px;
  z-index: 1;
}

</style>
